import * as React from 'react';
import { Subject } from '../../Model/core';
import { tagEventHandler } from '../../Event/Handlers';
import { setQuerystring } from '../../util';

type TagProps = {
    subject: Subject;
    onChange: (title?: string) => void;
    selectedTitle?: string;
};
export const Tag = ({ subject, selectedTitle, onChange }: TagProps) => {
    React.useEffect(() => {
        if (selectedTitle === subject.Title) {
            tagEventHandler.fire(subject);
        }
    }, []);
    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        const url = window.location.href;
        window.history.pushState({}, '', url);
        
        if (subject.Title === selectedTitle) {
            tagEventHandler.fire(undefined);
            setQuerystring({ value: '', key: 'subject' });
            onChange(undefined);
            return;
        }
        tagEventHandler.fire(subject);
        setQuerystring({ value: subject.Title, key: 'subject' });
        onChange(subject.Title);
        window.dispatchEvent(new Event('popstate'));
    };
    const cls = !selectedTitle || selectedTitle === subject.Title ? 'tag selected' : 'tag';
    return (
        <div className={cls}>
            <a href="#" title={subject.Title} onClick={handleClick}>{subject.Title}</a>
        </div>
    );
};